enum Civilities {
  MS = 'MS',
  MR = 'MR',
  NONE = 'NONE',
  COMPANY = 'COMPANY',
}

export default Civilities;
